module.exports = __webpack_public_path__ + "ph.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ph.svg
// module id = 1011
// module chunks = 0